import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { SharedModule } from '@app/shared/shared.module';
import { EventManager } from '@app/shared/utils/event-manager';

@Component({
  selector: 'slotcom-premium-pass-info',
  templateUrl: './premium-pass-info.component.html',
  styleUrls: ['./premium-pass-info.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class PremiumPassInfoModalComponent {
  premiumPassInfoModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.premiumPassInfoModalData.id, ModalType.View, this.premiumPassInfoModalData)
    );
  }
}
